import { render } from "./test2.vue?vue&type=template&id=ecb60984"
import script from "./test2.vue?vue&type=script&lang=js"
export * from "./test2.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/dynamicSegment/test2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecb60984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecb60984', __exports__)) {
    console.log('reload')
    api.reload('ecb60984', __exports__)
  }
  
  module.hot.accept("./test2.vue?vue&type=template&id=ecb60984", () => {
    console.log('re-render')
    api.rerender('ecb60984', render)
  })

}


export default __exports__